import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB7BrAhVDPuSq5osIh9Pt8JuPHbvrqorT4",
  authDomain: "imports-193fd.firebaseapp.com",
  projectId: "imports-193fd",
  storageBucket: "imports-193fd.firebasestorage.app",
  messagingSenderId: "408385069793",
  appId: "1:408385069793:web:f418688de0b8d2f1b84da0",
  measurementId: "G-GX6ZVKJECR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

// Export these so your Sign In / Sign Up pages can use them
export const auth = getAuth(app);
export const db = getFirestore(app);